import React from 'react'
import BaseComponent from "../../pages/base/BaseComponent";
import PropTypes from "prop-types";
import {isEmpty} from "enqc-utilities/src/utils/Utilities";
import {Card, Col, Row} from "@themesberg/react-bootstrap";
import label from "enqc-utilities/src/label/Label";
import {faCode} from "@fortawesome/free-solid-svg-icons";
import TextInput from "../input/TextInput";
import QRBarInput from "../input/QRBarInput";

export default class AssemblyRectifierControllerFormCard extends BaseComponent{

    constructor(props) {
        super(props);
        let {assembly} = this.props
        if(isEmpty(assembly)){
            assembly = {}
        }
        this.state = {
            assembly
        }
        let {rectifierControllerEntry} = assembly
        if(!rectifierControllerEntry){
            rectifierControllerEntry = {}
        }
        let {rectifierControllerSerialNumbers} = rectifierControllerEntry
        if(!rectifierControllerSerialNumbers){
            rectifierControllerSerialNumbers = []
        }

        this.inputRefs = rectifierControllerSerialNumbers.map(() => React.createRef());

    }

    componentWillReceiveProps(nextProps, nextContext) {
        if(nextProps!=this.props){
            let {assembly} = nextProps
            if(isEmpty(assembly)){
                assembly = {}
            }
            this.setState({assembly})
        }
    }

    start(){
        setTimeout(()=>{
            let firstInput = this.inputRefs[0].current
            if(firstInput){
                firstInput.callFocus()
            }
        }, 300)
    }


    render() {
        let {assembly} = this.state
        let {onPassed} = this.props
        onPassed = onPassed || (()=>{})

        if(isEmpty(assembly)){
            assembly = {}
        }
        let {rectifierControllerEntry} = assembly
        if(!rectifierControllerEntry){
            rectifierControllerEntry = {}
        }
        let {rectifierControllerSerialNumbers} = rectifierControllerEntry
        if(!rectifierControllerSerialNumbers){
            rectifierControllerSerialNumbers = []
        }
        let {updateProperties} = this.props
        if(!updateProperties){
            updateProperties = () => {}
        }

        return (
            <Card border="light" className="bg-white shadow-sm mb-4">
                <Card.Header>
                    {label.RectifierSerialNumber}
                </Card.Header>
                <Card.Body>
                    <Row>
                        {
                            rectifierControllerSerialNumbers.map((rectifierControllerSerialNumber, index)=>{
                                return (
                                    <Col key={index} xs={12} lg={6} className="text-left">
                                        <QRBarInput
                                            label={"#"+rectifierControllerSerialNumber.indexOrder}
                                            placeholder={" "}
                                            icon={faCode}
                                            value={rectifierControllerSerialNumber.serialCode}
                                            ref={this.inputRefs[index]}
                                            onFilled={() => {
                                                if(index+1 < rectifierControllerSerialNumbers.length){
                                                    if(this.inputRefs[index+1].current) {
                                                        this.inputRefs[index + 1].current.callFocus()
                                                    }
                                                }else{
                                                    onPassed()
                                                }
                                            }}
                                            onChange={(value) => {
                                                rectifierControllerSerialNumber.serialCode = value
                                                rectifierControllerSerialNumbers[index] = rectifierControllerSerialNumber
                                                rectifierControllerEntry.rectifierControllerSerialNumbers = rectifierControllerSerialNumbers
                                                updateProperties('rectifierControllerEntry', rectifierControllerEntry)
                                            }}
                                        />
                                    </Col>
                                )
                            })
                        }
                    </Row>
                </Card.Body>
            </Card>
        );
    }

}

AssemblyRectifierControllerFormCard.propTypes = {
    assembly : PropTypes.any,
    updateProperties : PropTypes.func.isRequired,
    onPassed : PropTypes.func
}